import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";
import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import { AlignJustify, CircleCheck, CircleOff, CircleStop, Grid2x2, Loader, Plus, PrinterCheck, Settings, WalletCards } from "lucide-react";
import { useDispatch } from "react-redux";
import { setIndexTimeSheet } from "store/header";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectGroup, SelectLabel, SelectItem } from "components/ui/select"; // or wherever your library path is

import SearchBar from "components/app/search-bar/SearchBar";
import PayrollSetting from "./PayrollSetting";

const PayrollNavbar = ({
  selectProducts,
  selectedProductIds,
  allIds,
  getShopEmployeePayrollCalculation,
  setIsDailogPayroll,
  setSelectProducts,
  isAllSelected,
  handleToggleSelectAll,
  setSelectedProductIds,
  handlePrint,
  loadingPrint,
  setSearchTextInput,
  view,
  changeView,
  payrollSetting,
  dataTimesheets,
  handleClick,
  selectedYear,
  setSelectedYear,
  years,
  months,
  selectedMonth,
  setSelectedMonth,
  openPopoverSetting,
  setOpenPopoverSetting,
  handleInputChange,
  formValues,
  setFormValues,
  setPayrollSetting,
  submitShopPayrollSetting,
  loadingsubmitShopPayrollSetting,
}: any) => {
  const dispatch = useDispatch();
  return (
    <nav className="border-gray-200 pt-5 flex items-center justify-between">
      <div className="flex items-center gap-3  ">
        {selectProducts && (
          <div className="flex items-center justify-center px-5 py-2 bg-blue-500 rounded-full text-white">
            Payroll Selected {selectedProductIds.length} / {allIds.length}
          </div>
        )}
        <HoverCardDetail
          title="Create New Payroll "
          description={
            <>
              <p className="mb-2 font-medium text-sm dark:text-white">Add new staff member to your team by entering their personal and job details.</p>
              <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                <li>Include contact information, role, and department.</li>
                <li>Set permissions and access levels if applicable.</li>
                <li>Ensures staff are properly tracked and managed in the system.</li>
              </ul>
            </>
          }
        >
          <label
            onClick={() => {
              getShopEmployeePayrollCalculation();
              setIsDailogPayroll(true);
            }}
            htmlFor=""
            className={`hover:border-3 transition-all duration-300 font-semibold rounded-full cursor-pointer lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300 
                        `}
          >
            <Plus className="font-semibold text-xl" />
          </label>
        </HoverCardDetail>
        <>
          {!selectProducts ? (
            <></>
          ) : (
            <>
              {selectedProductIds.length > 0 && (
                <>
                  <Popover>
                    <PopoverTrigger asChild>
                      <label className=" font-semibold cursor-pointer rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300">
                        <AlignJustify />
                      </label>
                    </PopoverTrigger>
                    <PopoverContent className="w-80 relative">
                      {dataTimesheets?.map((item: any, index: any) => {
                        return (
                          <HoverCardDetail title={item.title} description={item.description}>
                            <div
                              key={index}
                              className="gap-3 group  flex items-center px-3 py-2 rounded-md hover:bg-accent cursor-pointer"
                              onClick={() => {
                                handleClick(item.title);
                              }}
                            >
                              <span className="group-hover:scale-110 transition-all duration-300">{item.icon}</span>

                              <div className="flex flex-col ">
                                <span className="font-medium leading-none lg:text-md md:text-sm text-[13px]">{item.title}</span>
                                <span className="text-sm text-muted-foreground line-clamp-1">{item.label} </span>
                              </div>
                            </div>
                          </HoverCardDetail>
                        );
                      })}
                    </PopoverContent>
                  </Popover>
                </>
              )}
            </>
          )}
        </>
        {!selectProducts ? (
          <>
            <HoverCardDetail
              title="Select"
              description={
                <>
                  <p className="mb-2 font-medium text-sm dark:text-white">Select this item to perform actions like editing, deleting, or exporting.</p>
                  <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                    <li>Use checkboxes to include or exclude specific records.</li>
                    <li>Selected items can be affected by bulk actions.</li>
                    <li>Combine with “Select All” to manage groups efficiently.</li>
                  </ul>
                </>
              }
            >
              <label
                htmlFor=""
                className="hover:border-3 hover:scale-110 transition-all duration-300 font-semibold  rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
              >
                <CircleStop
                  onClick={() => {
                    dispatch(setIndexTimeSheet(""));
                    setSelectProducts(true);
                  }}
                  className="text-sm"
                />
              </label>
            </HoverCardDetail>
          </>
        ) : (
          <>
            <HoverCardDetail
              title="Select all staff timesheets "
              description={
                <>
                  <p className="mb-2 font-medium text-sm dark:text-white">Select all staff records or timesheets currently displayed for bulk actions.</p>
                  <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                    <li>Enables efficient management of multiple items at once.</li>
                    <li>Useful for batch printing, editing, or deleting.</li>
                    <li>Double-check your selection before proceeding.</li>
                  </ul>
                </>
              }
            >
              <label
                className={`hover:scale-110  transition-all duration-300 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 
                                  flex items-center justify-center cursor-pointer border 
                                  ${isAllSelected ? "border-blue-500 border-2" : "border-gray-300"} text-md`}
              >
                <CircleCheck
                  onClick={() => {
                    handleToggleSelectAll();
                  }}
                  className={`${isAllSelected ? "bg-blue-500 text-white rounded-full" : " rounded-full"} hover:border-3 `}
                />
              </label>
            </HoverCardDetail>
            <HoverCardDetail
              title="Select"
              description={
                <>
                  <p className="mb-2 font-medium text-sm dark:text-white">Select this item to perform actions like editing, deleting, or exporting.</p>
                  <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                    <li>Use checkboxes to include or exclude specific records.</li>
                    <li>Selected items can be affected by bulk actions.</li>
                    <li>Combine with “Select All” to manage groups efficiently.</li>
                  </ul>
                </>
              }
            >
              <label
                htmlFor=""
                className="hover:border-3 hover:scale-110 transition-all duration-300 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
              >
                <CircleOff
                  onClick={() => {
                    setSelectedProductIds([]);
                    setSelectProducts(false);
                  }}
                  className="text-sm"
                />
              </label>
            </HoverCardDetail>
          </>
        )}
      </div>

      {/* Search & View Switch */}
      {loadingPrint ? (
        <label
          onClick={() => {
            handlePrint();
          }}
          htmlFor=""
          className="hover:border-3 hover:scale-110 transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
        >
          <Loader className="animate-spin" />
        </label>
      ) : (
        <HoverCardDetail
          title="Daily Attendance Detail Report"
          description={
            <>
              <p className="mb-2 font-medium text-sm text-gray-800">View and analyze detailed attendance records for each employee on a daily basis.</p>
              <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
                <li>Monitor clock-in/out times, absences, and late entries.</li>
                <li>Track working hours, overtime, and shift compliance.</li>
                <li>Export reports for HR reviews or payroll processing.</li>
                <li>Identify patterns for attendance-related issues.</li>
              </ul>
            </>
          }
        >
          <label
            onClick={() => {
              handlePrint();
            }}
            htmlFor=""
            className="hover:border-3 hover:scale-110 transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
          >
            <PrinterCheck />
          </label>
        </HoverCardDetail>
      )}
      {/* ------setting------ */}

      <Popover open={openPopoverSetting === 1} onOpenChange={(isOpen) => setOpenPopoverSetting(isOpen ? 1 : null)}>
        <PopoverTrigger asChild>
          <label
            htmlFor=""
            className="hover:border-3  transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
          >
            <Settings />
          </label>
        </PopoverTrigger>

        <PopoverContent className="w-auto h-[calc(100vh-200px)] overflow-scroll">
          <PayrollSetting
            payrollSetting={payrollSetting}
            handleInputChange={handleInputChange}
            formValues={formValues}
            setFormValues={setFormValues}
            setPayrollSetting={setPayrollSetting}
            submitShopPayrollSetting={submitShopPayrollSetting}
            loadingsubmitShopPayrollSetting={loadingsubmitShopPayrollSetting}
          />
        </PopoverContent>
      </Popover>
      <div className="flex justify-between items-center ms-5 ">
        <div className="flex items-center gap-4  w-full ">
          <HoverCardDetail
            title="Select Month & Year"
            description={
              <>
                <p className="mb-2 font-medium text-sm dark:text-white">Choose a specific month and year to filter, view, or generate time-based records.</p>
                <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                  <li>View timesheets, attendance, or reports for a selected time period.</li>
                  <li>Useful for monthly payroll, scheduling, or performance tracking.</li>
                  <li>Ensures actions apply to the correct billing or reporting cycle.</li>
                </ul>
              </>
            }
          >
            <div className="flex">
              <Select
                value={selectedYear.toString()}
                onValueChange={(val) => {
                  setSelectedYear(Number(val));
                }}
              >
                <SelectTrigger className="w-[180px] py-3 ">
                  <SelectValue placeholder="Select Year" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectLabel>Years</SelectLabel>
                    {years.map((year: any) => (
                      <SelectItem key={year} value={`${year}`}>
                        {year}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          </HoverCardDetail>
          <HoverCardDetail
            title="Select Month & Year"
            description={
              <>
                <p className="mb-2 font-medium text-sm dark:text-white">Choose a specific month and year to filter, view, or generate time-based records.</p>
                <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                  <li>View timesheets, attendance, or reports for a selected time period.</li>
                  <li>Useful for monthly payroll, scheduling, or performance tracking.</li>
                  <li>Ensures actions apply to the correct billing or reporting cycle.</li>
                </ul>
              </>
            }
          >
            <div className="flex">
              <Select
                value={selectedMonth.toString()}
                onValueChange={(val) => {
                  setSelectedMonth(Number(val));
                }}
              >
                <SelectTrigger className="w-[180px] py-3">
                  <SelectValue placeholder="Select Month" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectLabel>Months</SelectLabel>
                    {months.map((month: any, index: any) => (
                      <SelectItem key={index} value={`${index}`}>
                        {month}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          </HoverCardDetail>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="flex-1 ms-4 me-2">
          <div className="relative">
            <SearchBar
              placeholder="Search"
              onValueChange={(value: any) => {
                setSearchTextInput(value);
              }}
            />
          </div>
        </div>

        {/* View Toggle Button */}
        <HoverCardDetail
          title=""
          description={
            <>
              <p className="mb-2 font-medium text-sm dark:text-white">Switch between different layouts to view employee timesheets records in the format you prefer.</p>
              <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                <li>
                  <strong>Card View:</strong> Shows each employee timesheets as an individual card with profile info and actions.
                </li>
                <li>
                  <strong>Table View:</strong> Displays employees timesheets in a structured table for sorting, scanning, and bulk actions.
                </li>
                <li>Use the layout that best suits your workflow or screen size.</li>
              </ul>
            </>
          }
        >
          <div className="relative">
            {view === "card" ? (
              <button
                onClick={() => changeView("table")}
                className="font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
              >
                <Grid2x2 className="font-semibold size-5" />
              </button>
            ) : (
              <button
                onClick={() => changeView("card")}
                className="font-semibold rounded-full w-10 h-10 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
              >
                <WalletCards className="text-xl" />
              </button>
            )}
          </div>
        </HoverCardDetail>
      </div>
    </nav>
  );
};

export default PayrollNavbar;
